import { useState } from "react";
import { QuickLogModal, type QuickLogType } from "../components/QuickLogModal.js";
import { useSession } from "../lib/session.js";
import {
  IconBody,
  IconClipboard,
  IconDumbbell,
  IconHeart,
  IconLeaf,
  IconProgress,
  IconToday
} from "../components/icons.js";

interface Tile {
  type: QuickLogType;
  label: string;
  icon: React.ReactNode;
  recoveryRelevant?: boolean;
}

const TILES: Tile[] = [
  { type: "weight", label: "Weight", icon: <IconProgress /> },
  { type: "water", label: "Water", icon: <IconLeaf /> },
  { type: "walk", label: "Walk", icon: <IconToday /> },
  { type: "recovery", label: "Recovery check-in", icon: <IconHeart />, recoveryRelevant: true },
  { type: "measurement", label: "Measurement", icon: <IconBody /> },
  { type: "hunger", label: "Hunger / craving", icon: <IconClipboard /> },
  { type: "readiness", label: "Readiness", icon: <IconDumbbell /> },
  { type: "sleep", label: "Sleep", icon: <IconToday /> },
  { type: "pain", label: "Pain", icon: <IconHeart /> },
  { type: "medication", label: "Medication", icon: <IconClipboard /> }
];

export function QuickLogPage() {
  const { user } = useSession();
  const [modal, setModal] = useState<QuickLogType | null>(null);
  void user;

  return (
    <div>
      <div className="page-header">
        <h1>Quick Log</h1>
        <p className="subtitle">One tap to capture what just happened.</p>
      </div>

      <div className="log-grid">
        {TILES.map((tile) => (
          <button key={tile.type} className="log-tile" onClick={() => setModal(tile.type)} type="button">
            <span className="log-tile-icon">{tile.icon}</span>
            <span>{tile.label}</span>
          </button>
        ))}
      </div>

      <p className="dim text-sm center mt-6" style={{ maxWidth: 420, margin: "var(--space-6) auto 0" }}>
        Weight, measurements, meals, workouts, and progress photos get their own
        richer logging as those sections ship (Phases 4–6).
      </p>

      {modal && <QuickLogModal type={modal} onClose={() => setModal(null)} />}
    </div>
  );
}
